<template>
  <v-dialog v-if="!loading" v-model="dialog" width="90vw">
    <v-card height="80vh">
      <v-container fluid>
        <v-card-title class="justify-center">Clearing detail overview (EUR)</v-card-title>
        <div class="text-caption" style="font-style: italic;">Details: {{ details.length }}, Total amount: €{{ formatAmount(this.amount) }}</div>
        <v-divider class="mb-2" />
        <div v-if="details.length > 0">
          <ul class="pl-0">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th style="width: 20vw;">Order ID</th>
                  <th style="width: 10vw;">Booking</th>
                  <th style="width: 10vw;">Type</th>
                  <th style="width: 10vw; text-align: right;">Amount</th>
                  <th>Remark</th>
                </tr>
              </thead>
            </v-simple-table>
            <li style="height: 58vh; overflow-y: auto;">
              <v-simple-table dense v-if="details.length > 0">
                <tbody v-for="(detail, i) in details" :key="i">
                  <tr :class="{ 'color': i % 2 !== 0 }" style="cursor: default">
                    <td style="width: 20vw;">{{ detail.order_id }}</td>
                    <td v-if="detail.huov_encrid!==''" style="width: 10vw; color: blue; cursor: pointer;" @click="detail.booking!==$router.open('/huov/onHuov/' + detail.huov_encrid)">{{ detail.booking }}</td>
                    <td v-else style="width: 10vw;">{{ detail.booking }}</td>
                    <td style="width: 10vw;">{{ detail.type }}</td>
                    <td style="width: 10vw;" align="right">{{ formatAmount(detail.amount) }}</td>
                    <td>{{ detail.remark }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </li>
          </ul>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>
  
<script>
    
  export default {
    components: {
    },  
    data() {
      return {
        dialog: false,
        loading: true,
        id:'',
        details: [],
        amount:''
      }
    },
    methods: {
      open(id, amount) {
        this.loading=true,
        this.details = [],
        this.id = id;        
        this.amount = amount;
        this.getData(id);
      },
      formatAmount(amount) {
        let xamount = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount).replace('€', '');
        if(amount === 0) {
          return '';
        } else return xamount;
      },      
      getData(id){
        this.$axios
          .post("ares/json/ares/task/fin/paynl/getPclrOfPncl.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "getClearingDetails"
            },
            getClearingDetails: {
              pncl_id: id,
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
              this.dialog = true; this.loading = false;
            } else {
              this.details = res.data.getClearingDetails;
              this.dialog = true; this.loading = false;
            }
          })
      }
    }
  }
</script>

<style scoped>
.ul {
  list-style-type: none !important;
  position:absolute;
  left: 0;
  right: 0;
  top: 70px;
  bottom: 20px;
  margin: 0;
  overflow-y: auto;
}
.color {
  background-color: #faf8f8;
}
</style>
  
